<template>
	<div class="health">
		<span v-for="(bin, index) in healthBins"
			:key="index"
			:style="{ width: binWidth(bin, healthTotal) }">
			<template v-if="bin > 0">
				<div class="stars">
					<i v-for="star in (index + 1)" class="el-icon-star-on"></i>
				</div>
				<label>
					{{ binLabel(bin, healthTotal) }}
				</label>
			</template>
		</span>
	</div>
</template>
<script>
import FoodAnalysis from '..'

export default {
	name: 'lifestyle-table-health-column',
	extends: FoodAnalysis
}
</script>

<style lang="scss" scoped>
$red: rgb(249, 90, 90);
$yellow: rgb(245, 166, 35);
$green: rgb(126, 198, 53);

.health {
	height: 32px;
	> span {
		position: relative;
		float: left;
		height: 12px;
		margin-top: 18px;

		.stars, label {
			position: absolute;
			left: 0px;
			width: 100%;
			text-align: center;
		}

		> .stars {
			bottom: 8px;
			overflow: visible;
			white-space: nowrap;
		}
		> label {
			color: #3f3f3f;
			bottom: -6px;
			font-size: 10px;
			font-weight: 700;
			letter-spacing: 1px;
		}
	}
	span:first-child {
		background: lighten($red, 10%);
		color: $red;
	}
	span {
		background: lighten($yellow, 10%);
		color: $yellow;
	}
	span:last-child {
		background: lighten($green, 10%);
		color: $green;
	}
}
</style>
